import React from 'react';
import { Typography, Box, Grid } from '@mui/material';
import GTranslateIcon from '@mui/icons-material/GTranslate';
import VerifiedIcon from '../../assets/images/prescreen_operator.png';
import TrustedCanadian from '../../assets/images/trusted_by_canadian.png';
import MoneyOffIcon from '../../assets/images/noshady_fees.png';

const cardData = [
  {
    icon: <img src={VerifiedIcon} alt="verified operator" width={26} height={32} />,
    title: 'Vetted & Pre-Screened Operators',
    description:
      'We work only with licensed and verified tour operators. No guesswork, no shady companies — just top-rated excursions you can feel proud to promote.',
  },
  {
    icon: <GTranslateIcon fontSize="large" sx={{ color: '#FF6B00' }} />,
    title: 'English & Spanish Customer Support',
    description:
      'Whether your clients speak English or Spanish, our friendly team is ready to help. Bilingual support ensures clear communication and a smooth booking experience.',
  },
  {
    icon: <img src={MoneyOffIcon} alt="no hidden fees" width={42} height={32} />,
    title: 'No Shady Upsells or Hidden Fees',
    description:
      'We believe in honest pricing. What your client sees is what they pay — no surprise costs, aggressive upsells, or last-minute switches.',
  },
  {
    icon: <img src={TrustedCanadian} alt="canadian trust" width={32} height={32} />,
    title: 'A Trusted Canadian-Owned Business',
    description:
      'Backed by a Canadian company with North American standards of service, safety, and transparency — your referrals are in good hands.',
  },
];

const WhyTrustCanam = () => (
  <Box width="100%" py={8} px={{ xs: 2, sm: 4, md: 8, lg: 15 }} bgcolor="#fff">
    <Box textAlign="center" mb={6}>
      <Typography
        variant="h4"
        fontWeight={900}
        fontFamily="Lato"
        fontSize={{ xs: '1.5rem', md: '2rem' }}
      >
        Why CanAm is Trusted by Tourists
      </Typography>
      <Typography
        maxWidth="900px"
        mx="auto"
        mt={2}
        fontFamily="Lato"
        fontSize={{ xs: '14px', md: '16px' }}
        color="#333"
        textAlign="center"
      >
        Tourists choose CanAm Excursions not just for the unforgettable experiences — but because they feel safe, informed, and confident every step of the way. Here&apos;s why affiliates love recommending us:
      </Typography>
    </Box>

    <Grid container spacing={4} justifyContent="center">
      {cardData.map((card, index) => (
        <Grid item xs={12} sm={6} md={6} key={index}>
          <Box textAlign="center" px={{ xs: 2, md: 6 }}>
            <Box mb={2}>{card.icon}</Box>
            <Typography
              variant="h6"
              fontWeight={700}
              fontFamily="Lato"
              fontSize={{ xs: '1rem', md: '1.1rem' }}
              gutterBottom
            >
              {card.title}
            </Typography>
            <Typography
              fontFamily="Lato"
              fontSize="14px"
              color="#000000CC"
            >
              {card.description}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default WhyTrustCanam;
